module.exports = __webpack_public_path__ + "static/media/vaneyk-13.02a374c7.jpeg";